module.exports = __webpack_public_path__ + "img/1438.9da1ff58.jpg";